
export default {
  data() {
    return {
      searchtext: undefined,
      reloadTimer: null,
      firstLoad: true,
    }
  },
  mounted() {
    this.searchtext = this.$route.query.search || ""
    // console.log("mixin", "mounted()", this.$route)
  },
  watch: {
    // 'this.$route.query.searchtext': () => {
    //   console.log("mixin", "watch-this.$route.query.searchtext")
    //   this.searchtext = this.$route.query.search || ""
    //   this.load(this.searchtext)
    // },
    searchtext(value, prevValue) {
      // console.log("mixin", "watch-searchtext", value, prevValue)
      if (value != this.$route.query.search) {
        // Using undefined removes the query param from the URI
        this.$router.replace({ query: { "search": value != "" ? value : undefined } })
      }
      if (prevValue != value) {
        if (this.reloadTimer) {
          clearTimeout(this.reloadTimer);
        }
        if (this.firstLoad) {
          this.firstLoad = false
          this.load(value);
        } else {
          this.reloadTimer = setTimeout(() => {
            this.offset = 0;
            this.load(value);
            this.reloadTimer = null
          }, 500);
        }
      }
    },
  },
}